import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonVariant, IconName, IconSize } from '@as/cotopaxi';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePageShow } from '../hooks/usePageShow';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
import { makeGetWishlistCounter } from '../redux/wishList/selectors/WishListSelectors';
const WishListMenuItemContainer = ({ link }) => {
    const dispatch = useDispatch();
    const itemCount = useSelector(makeGetWishlistCounter());
    const hasItems = !!itemCount && itemCount > 0;
    usePageShow(() => {
        dispatch(wishListActions.getWishListProducts());
    });
    useEffect(() => {
        dispatch(wishListActions.getWishListProducts());
    }, []);
    const handleButtonClick = () => {
        window.location.href = link;
    };
    return (_jsx("div", { "data-analytics-bannerid": "header-wishlist", children: _jsx(Button, { onClick: handleButtonClick, variant: ButtonVariant.NAVIGATION, badge: hasItems ? itemCount : undefined, dataQA: "wishlist", dataBadgeQA: "wishlist_counter", icon: {
                name: IconName.HEART,
                size: IconSize.MAJOR,
            }, title: "wishlist icon" }) }));
};
export default WishListMenuItemContainer;
